import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { CustomErrorStateMatcher } from '../../../shared/models/custom-error-state';
import { NtCompany } from '../../../shared/models/nt-company';

@Component({
  selector: 'app-asset-convert-kit',
  templateUrl: './asset-convert-kit.component.html',
  styleUrls: ['./asset-convert-kit.component.scss']
})
export class AssetConvertKitComponent implements OnInit {
    @Input() value: any;
    @Input() form: FormGroup;
    @Input() currency = 'GBP';

    @Output('addChild') addChildEvent = new EventEmitter<boolean>();
    @Output('removeChild') removeChildEvent = new EventEmitter<number>();


    errorMatcher = new CustomErrorStateMatcher();

    constructor(private fb: FormBuilder) {
    }

    ngOnInit() {
    }

    addChild() {
        this.addChildEvent.emit(true);

    }

    get moreThanOneChild() {
        return this.childrenArray.length > 1;
    }
    
    fixFloat(value: number, precision: number): number {
        return parseFloat(value.toFixed(precision));
    }

    removeChild(i: number) {
        this.childrenArray.removeAt(i);
    }

    get f() { return this.form.controls; }

    get childrenArray() { return this.form.controls["children"] as FormArray; }

    
    
}
